<message [icon]="icon"
         message="{{message}}"
         [html]="html"
         [showButton]="showButton"
         [showLinkToHelp]="showLinkToHelp"
         [showLinkToContact]="showLinkToContact"
         [showLinkToStart]="showLinkToStart">
</message>
